<div class="sync-progress-details">
  <div class="sync-progress-details__item">
    <local-seo-color-icon
      backgroundColor="dark-green"
      icon="check"
      [text]="'LISTING_SYNC.SYNCING_PROGRESS_SUMMARY_CARD.SYNC_IN_PROGRESS_DETAILS.SYNCED_OR_SUBMITTED' | translate"
    ></local-seo-color-icon>
    <span>{{ data.syncedSourcesCount || 0 }}</span>
  </div>
  <div class="sync-progress-details__item">
    <local-seo-color-icon
      backgroundColor="green"
      icon="sync"
      [text]="'LISTING_SYNC.SYNCING_PROGRESS_SUMMARY_CARD.SYNC_IN_PROGRESS_DETAILS.SYNC_IN_PROGRESS' | translate"
    ></local-seo-color-icon>
    <span>{{ data.syncInProgressSourcesCount || 0 }}</span>
  </div>
  <div class="sync-progress-details__item">
    <local-seo-color-icon
      backgroundColor="grey"
      icon="close"
      [text]="'LISTING_SYNC.SYNCING_PROGRESS_SUMMARY_CARD.SYNC_IN_PROGRESS_DETAILS.NOT_SYNCING' | translate"
    ></local-seo-color-icon>
    <span>{{ data.notSyncingSourcesCount || 0 }}</span>
  </div>
</div>
